
import { Grid } from '@mui/material';
import { useEffect, useMemo } from 'react';
import Dialog, { IDefaultDialogProps } from '../../Dialog';
import { ActionButton } from '../../Button';
import { useLanguageContext } from '../../../contexts/LanguageContext';
import DefaultConstants from '../../../data/Constants';
import useState from '../../../hooks/useState';
import IServiceOrder from '../../../interfaces/IServiceOrder';
import SelectField from '../../SelectField';
import { useAuthContext } from '../../../contexts/AuthContext';


interface IUpdateDepartmentDialogProps extends IDefaultDialogProps {
    serviceOrder: IServiceOrder;
    handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
}

interface IStateValues {
    departmentId: number;
}

const UpdateDepartmentDialog: React.FC<IUpdateDepartmentDialogProps> = ({
    open,
    handleClose,
    serviceOrder,
    handleSubmit
}) => {
    const { translate } = useLanguageContext();
    const { enterprise } = useAuthContext();

    const state = useState<IStateValues>({
        departmentId: 0
    });


    useEffect(() => {
        if (open) {
            state.update('departmentId', +(serviceOrder.department?.id ?? 0));
        }
        // eslint-disable-next-line
    }, [open]);
    

    const dialogActions = useMemo(() => {
        return [
            <ActionButton action='cancel' onClick={handleClose} />,
            <ActionButton action='save' type='submit' />
        ];
        // eslint-disable-next-line
    }, [translate]);

    
    return (
        <Dialog
            open={open}
            handleClose={handleClose}
            title={translate('editDepartment')}
            dialogActions={dialogActions}
            onSubmit={handleSubmit}
            className='dialogactions-spacebetween overflow-inherit'
            absolute={true}
            dividers={true}
        >
            <Grid container rowSpacing={DefaultConstants.gridRowSpacing}>
                <Grid item xs={12}>
                    <SelectField
                        label={translate('department')}
                        name='departmentId'
                        value={state.values.departmentId}
                        onChange={e => state.update(e.target.name, e.target.value)}
                        data={[{ value: 0, text: translate('undefined') }].concat((enterprise?.departments ?? []).map(d => {
                            return {
                                value: +d.id,
                                text: d.name
                            };
                        }))}
                    />
                </Grid>
            </Grid>
        </Dialog>
    );
}

export default UpdateDepartmentDialog;